import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { useFormContext } from '../FormContext';
import ConfigFieldControl from './components/ConfigFieldControl';
import FormConfigTitleDescription from './FormConfigTitleDescription';
import FormConfigRequired from './FormConfigRequired';
const FormConfigDate = () => {
    var _a, _b, _c, _d, _e, _f;
    const { formState, setFormState, notifyFormEdit } = useFormContext();
    const element = formState.selectedFormElement;
    if (!element.config)
        element.config = {};
    return (React.createElement(React.Fragment, null,
        React.createElement(FormConfigTitleDescription, null),
        React.createElement(FormConfigRequired, null),
        React.createElement(ConfigFieldControl, null,
            React.createElement(TextField, { select: true, fullWidth: true, variant: 'outlined', label: 'Date Type', placeholder: (_a = element.config) === null || _a === void 0 ? void 0 : _a.dateType, value: (((_b = element.config) === null || _b === void 0 ? void 0 : _b.dateType) || 'any'), onChange: event => {
                    element.config.dateType = event.target.value;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } },
                React.createElement(MenuItem, { value: 'any' }, "Any Date"),
                React.createElement(MenuItem, { value: 'birth' }, "Birth Date"),
                React.createElement(MenuItem, { value: 'future' }, "Future Date"))),
        React.createElement(ConfigFieldControl, null,
            React.createElement(KeyboardDatePicker, { fullWidth: true, clearable: true, variant: 'dialog', inputVariant: 'outlined', label: 'Min Date', format: 'MM/dd/yyyy', maxDate: ((_c = element.config) === null || _c === void 0 ? void 0 : _c.maxDate) || undefined, value: ((_d = element.config) === null || _d === void 0 ? void 0 : _d.minDate) || null, onChange: date => {
                    element.config.minDate = date || undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(KeyboardDatePicker, { fullWidth: true, clearable: true, variant: 'dialog', inputVariant: 'outlined', label: 'Max Date', format: 'MM/dd/yyyy', minDate: ((_e = element.config) === null || _e === void 0 ? void 0 : _e.minDate) || undefined, value: ((_f = element.config) === null || _f === void 0 ? void 0 : _f.maxDate) || null, onChange: date => {
                    element.config.maxDate = date || undefined;
                    setFormState(Object.assign(Object.assign({}, formState), { selectedFormElement: element }));
                    notifyFormEdit();
                } }))));
};
export default FormConfigDate;
//# sourceMappingURL=FormConfigDate.js.map